/**
 * Feature hook: Channel store state + fetchChannelConfig thunk (uses channelAPI).
 */
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { fetchChannelConfig, saveChannelConfigurationThunk, fetchIsPrimaryChannel } from "../slices/channel/channelThunks";

export function useChannel() {
  const dispatch = useAppDispatch();
  const channelState = useAppSelector((state) => state.ChannelStore);
  const onChannelConfigLoad = useCallback(
    (teamsContext) => dispatch(fetchChannelConfig(teamsContext)),
    [dispatch]
  );
  const onSaveChannelConfiguration = useCallback(
    (teamsContext, objectConnections, activePage) => dispatch(saveChannelConfigurationThunk({ teamsContext, objectConnections, activePage })),
    [dispatch]
  );
  const onCheckIsPrimaryChannel = useCallback(
    (teamsContext) => dispatch(fetchIsPrimaryChannel(teamsContext)),
    [dispatch]
  );

  return {
    ...channelState,
    onChannelConfigLoad,
    onSaveChannelConfiguration,
    onCheckIsPrimaryChannel,
  };
}
